import React, { useState, useContext } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';
import UI from '../ui';
import Auth from './Auth.component';
import { SsoForm } from './SsoForm.component';

const { ModalContext } = ModalModule;
const {
	Session,
	Navigation,
	Util: { getCookie, setCookie, removeCookie },
	Logger,
} = Utils;
const { WrappedButton, WrappedCheckbox, WrappedInputTextWithLabel } = UI;

export const HeaderSignIn = ({ SSOError, signInCallback }) => {
	const printUsername = getCookie('print_username');

	const [username, setUsername] = useState(printUsername || '');
	const [password, setPassword] = useState('');
	const [rememberUsername, setRememberUsername] = useState(!!printUsername);
	const [errorMessage, setErrormessage] = useState('');
	const [isAuthenticating, setIsAuthenticating] = useState(false);
	const [status, setStatus] = useState(null);

	const { showModal } = useContext(ModalContext);

	const { isSso } = Session.getCalculatedSettings();

	// stop rendering Auth, reflect Auth's status response, and render any error messages
	const authCallback = ({ status: authStatus, errorDescription = '' }) => {
		setIsAuthenticating(false);
		setStatus(authStatus);
		setErrormessage(errorDescription);
		signInCallback({ status: authStatus });
	};

	const renderAuthenticateUser = () => (
		<Auth
			userName={username}
			password={password}
			loginSource="HeaderSignIn"
			callback={authCallback}
		/>
	);

	const onFieldChange = e => {
		const { value, name } = e.target;

		setStatus(null);
		if (name === 'username') {
			setUsername(value);
		} else {
			setPassword(value);
		}
	};

	const onRememberUsernameToggle = () => {
		setRememberUsername(prevState => !prevState);
	};

	const onSignIn = e => {
		e.preventDefault();

		Logger.saveActionData('Header Sign In Button Clicked');

		if (username !== '' && password !== '') {
			Logger.logToServer({
				category: 'ui_interaction',
				action: 'click',
				ui_element: 'sign_in_button',
			});

			if (rememberUsername) {
				setCookie('print_username', username, 91, '/', Session.getBrand().domain);
			} else {
				removeCookie('print_username');
			}
		}

		setIsAuthenticating(true);
	};

	const onClickRegistration = () => {
		const cookieName = 'existingcust';

		if (getCookie(cookieName) !== undefined) {
			removeCookie(cookieName);
		}

		Logger.logToServer({
			category: 'ui_interaction',
			action: 'click',
			ui_element: 'sign_up_link',
		});

		Navigation.navigateTo('register');
	};

	const launchForgotUsernameModal = () => {
		Logger.logToServer({
			category: 'ui_interaction',
			action: 'click',
			ui_element: 'forgot_username_link',
		});
	};

	const launchForgotPasswordModal = () => {
		Logger.logToServer({
			category: 'ui_interaction',
			action: 'click',
			ui_element: 'forgot_password_link',
		});
	};

	const authFailed = status === false;

	return (
		<div
			className="common-authentication authentication-header-signin"
			data-qa="header-form"
			{...{ dataqa: 'header-form' }}
		>
			{isAuthenticating && renderAuthenticateUser()}
			{isSso && <SsoForm SSOError={SSOError} />}
			{!isSso && (
				<>
					<form className="p-grid" onSubmit={onSignIn}>
						{authFailed && <div className="error-message">{errorMessage}</div>}
						<WrappedInputTextWithLabel
							isInputInvalid={authFailed}
							className="p-col-12"
							uiElementConfig={{
								type: 'text',
								placeholder: 'Username',
								onChange: onFieldChange,
								value: username,
								dataqa: 'header-username',
								name: 'username',
							}}
						/>
						<WrappedInputTextWithLabel
							isInputInvalid={authFailed}
							className="p-col-12"
							uiElementConfig={{
								type: 'password',
								placeholder: 'Password',
								onChange: onFieldChange,
								value: password,
								dataqa: 'header-password',
								name: 'password',
							}}
						/>
						<WrappedCheckbox
							inputId="header-cb"
							value={rememberUsername}
							onChange={onRememberUsernameToggle}
							checked={rememberUsername}
							htmlFor="header-cb"
							dataqa="header-remember-checkbox"
						>
							Remember Username
						</WrappedCheckbox>
						<div className="signin-row">
							<WrappedButton
								label="Sign In"
								type="submit"
								disabled={isAuthenticating}
								dataqa="header-signin"
							/>
							<div
								className="link header-registration"
								onClick={onClickRegistration}
								role="link"
								tabIndex={0}
								data-qa="header-register-link"
								{...{ dataqa: 'header-register-link' }}
							>
								Register
							</div>
						</div>
					</form>
					<div className="forgot-section">
						<div className="forgot-row">
							Forgot
							<span
								className="link forgot-modal"
								onClick={launchForgotUsernameModal}
								role="link"
								tabIndex={0}
								data-qa="header-forgotusername-link"
								{...{ dataqa: 'header-forgotusername-link' }}
							>
								username
							</span>
						</div>

						<div className="forgot-row">
							or
							<span
								className="link forgot-modal"
								onClick={launchForgotPasswordModal}
								role="link"
								tabIndex={0}
								data-qa="header-forgotpassword-link"
								{...{ dataqa: 'header-forgotpassword-link' }}
							>
								password?
							</span>
						</div>
					</div>
				</>
			)}
		</div>
	);
};
